/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import "../index.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <main>{children}</main>
      <footer className="footer">
        <div className="container">
          <ul className="list-inline">
            <li className="list-inline-item"><Link to="#top">Back to top</Link></li>
            <li className="list-inline-item"><Link to="/">Home</Link></li>
            <li className="list-inline-item"><Link to="/rss.xml">RSS</Link></li>
            <li className="list-inline-item"><a href="https://keybase.io/samuelcotterall" rel="me">Keybase</a></li>
            <li className="list-inline-item"><a href="https://twitter.com/samuelcotterall" rel="me">Twitter</a></li>
            <li className="list-inline-item"><a href="https://www.linkedin.com/in/samuelcotterall/" rel="me">LinkedIn</a></li>
          </ul>
        </div>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
